<template>
    <footer>
        <div class="links-container">
            <router-link to="/about_program">{{translate("about_program")}}</router-link>
            <span>|</span>
            <router-link to="/statute">{{translate("clause_title")}}</router-link>
            <span>|</span>
            <span>v.{{ getVersion() }}</span>
        </div>
        <p>© {{currentYear}} {{copyright[selected]}}. {{translate("all_right_reserved")}}</p>
        <search/>
        <div class="icon-dh">
            <a href="https://digitalholding.pl" title="#tworzymyOprogramowanie"> Created by <img src="/gfx/svg/logo_black.svg" alt="digitalholding logo"/></a>
        </div>
        <div class="icon-dh netecs-logo">
            <a href="https://netecs.eu" title="#czysteJutro"> Powered By <img src="/gfx/svg/netecs.svg" alt="netecs_logo"/></a>
        </div>
    </footer>

</template>

<script>
    import Search from '@/components/bottom/Search.vue';
    import { version } from '/package.json';

    export default {
        name: "Bottom",
        components: {
            Search
        },
        data() {
            return {
                copyright: {
                    nvs: 'NVS',
                    nestro: 'Nestro',
                    netecs: 'Netecs'
                },
                selected: 'nvs'
            }
        },
        watch: {
            $route(to, from) {
                this.updateCopyright();
            }
        },
        methods:{
            getVersion() {
                return version;
            },
            updateCopyright() {
                if (this.$route.name === 'result_form') {
                    let company = this.$store.state.userCompany;
                    if (!company) return;
                    company = company.toLocaleLowerCase();
                    if (company.includes('nestro')) {
                        this.selected = 'nestro';
                    } else if (company.includes('netecs')) {
                        this.selected = 'netecs';
                    } else {
                        this.selected = 'nvs'
                    }
                } else {
                    this.selected = 'nvs'
                }
            },
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },
        },
        computed: {
            currentYear() {
                let date = new Date();
                return date.getFullYear();
            }
        }
    }
</script>

<style scoped lang="scss">

    @media  (max-width: 1120px) {
        footer {
           .icon-dh {
               position: relative;
               left: 0;
               bottom: 0;

               &.netecs-logo {
                   img {
                       width: 80px;
                   }
               }

               img {
                   width: 35px;
               }
           }
        }
    }

    @media (min-width: 1120px) and (max-width: 1600px) {
        footer {
            .icon-dh {
                &.netecs-logo {
                    left: 15%;

                    img {
                        width: 100px;
                    }
                }
                img {
                    width: 45px;
                }
            }
        }
    }

</style>
